import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { estimateTemplateEndpoints } from '@/lib/api/endpoints';
import { estimateTemplateKeys } from '@/lib/queryKeys';
import type { EstimateTemplate } from '@/types/estimateTemplate';

/**
 * Fetches a single estimate template by ID from the operations microservice.
 */
export function useEstimateTemplate(id: string) {
  return useApiQuery<EstimateTemplate>({
    queryKey: estimateTemplateKeys.detail(id),
    queryFn: () => apiGet<EstimateTemplate>(operationsClient, estimateTemplateEndpoints.detail(id)),
    enabled: Boolean(id),
  });
}
